import { ContactChannels, CompanyMap } from "@/components/contacts/ContactParts";
import { Seo } from "@/components/seo/Seo";
import { SEO } from "@/data/seo";
import { MaskedLines } from "@/components/motion/MaskedLines";
import { COMPANY_FACTS } from "@/data/company";

const CompanyFacts = () => (
  <section className="mt-20 rounded-[2rem] bg-navy p-8 text-ivory sm:p-12" data-testid="company-facts">
    <p className="text-[13px] uppercase tracking-[0.25em] text-copper-light">Dati aziendali</p>
    <h2 className="mt-4 font-display text-3xl font-medium sm:text-4xl">Chi c'è dietro Perfero</h2>
    <dl className="mt-10 grid gap-x-10 gap-y-7 sm:grid-cols-2 lg:grid-cols-3">
      {COMPANY_FACTS.map(({ label, value, href }) => (
        <div key={label} className="border-t border-ivory/15 pt-4">
          <dt className="text-[13px] uppercase tracking-[0.18em] text-ivory/70">{label}</dt>
          <dd className="mt-2 break-words text-[17px] text-ivory" data-testid={`company-fact-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            {href ? <a href={href} className="underline decoration-copper-light/60 underline-offset-4 transition-colors hover:text-copper-light">{value}</a> : value}
          </dd>
        </div>
      ))}
    </dl>
  </section>
);

export default function Contacts() {
  return (
    <div className="bg-ivory pb-28 pt-40" data-testid="contacts-page">
      <Seo {...SEO.contacts} />
      <div className="container-pf">
        <div className="max-w-3xl">
          <p className="eyebrow">Contatti</p>
          <h1 className="mt-5 font-display text-4xl font-medium leading-[1.02] text-navy sm:text-5xl lg:text-6xl">
            <MaskedLines onLoad delay={0.1} lines={["Siamo qui", <em key="em" className="italic text-copper">per te.</em>]} />
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-slate2">Per domande sui prodotti, su un ordine o su una consegna puoi telefonarci o scriverci ai recapiti qui sotto.</p>
        </div>
        <div className="mt-14 grid gap-8 lg:grid-cols-12 lg:items-start">
          <div className="lg:col-span-5"><ContactChannels /></div>
          <div className="lg:col-span-7"><CompanyMap /></div>
        </div>
        <CompanyFacts />
      </div>
    </div>
  );
}
